import { useSearch } from "@tanstack/react-router";
import { AppShell } from "../components/shell/app-shell";

/**
 * `/you/plan` — the address the auto-renewal disclosure names.
 *
 * Every subscriber is shown a sentence that ends "Cancel any time in Settings →
 * Plan", and California's ARL (docs/plans.md §9, applied to everyone) requires
 * that the place named be a real, self-serve place in the product. It also has
 * to survive a subscription checkout, which leaves the origin and comes back
 * with `?paid=`.
 *
 * So the address stays, and it does one thing: mount the shell with the plans
 * open — or, with `?portal=1`, the panel's index, which is where the
 * processor's billing portal sends the subscriber back to (wave 87). The panel behind it is the same ladder, the same disclosure, the same
 * consent checkbox and the same two-step cancel it has always been.
 */
export function YouPlanRoute() {
  const { paid, portal } = useSearch({ from: "/you/plan" });
  // Back from the billing portal (wave 87): the panel's index, where the card
  // and the billing details are, and not the ladder.
  return (
    <AppShell initialOverlay={{ kind: "billing", view: portal ? "home" : "plans" }} paid={paid} />
  );
}
